import { __decorate, __extends, __metadata, __param } from 'tslib';
import { NgControl, FormsModule } from '@angular/forms';
import { Directive, HostBinding, Input, ViewChild, ElementRef, HostListener, Component, ViewEncapsulation, ChangeDetectionStrategy, forwardRef, Self, Optional, ChangeDetectorRef, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { UkSelectionChange, UkBaseFormControl, UkFormGroupComponent, UIKitCommonModule } from '@uikit/components/common';
import { KEYS, IS_SYSTEM_KEY, IS_LETTER_KEY } from '@uikit/components/helpers';
import { UkFormControlsModule } from '@uikit/components/uk-form-controls';

// tslint:disable: curly
// tslint:disable: variable-name
var UkSelectTrigger = /** @class */ (function () {
    function UkSelectTrigger() {
    }
    UkSelectTrigger = __decorate([
        Directive({
            selector: 'uk-dropdown-trigger'
        })
    ], UkSelectTrigger);
    return UkSelectTrigger;
}());
var UkDropdownComponent = /** @class */ (function (_super) {
    __extends(UkDropdownComponent, _super);
    function UkDropdownComponent(ngControl, cdRef) {
        var _this = _super.call(this, ngControl, 'dropdown', cdRef) || this;
        _this.cdRef = cdRef;
        _this.role = 'listbox';
        _this.tabidx = '0';
        _this._hasPendingChange = false;
        _this.isMenuOpen = false;
        _this._triggerFontSize = 0;
        // Key Navigation
        _this.fowardKeys = [KEYS.ArrowDown, KEYS.ArrowRight];
        _this.backKeys = [KEYS.ArrowUp, KEYS.ArrowLeft];
        _this._selectedIndex = -1;
        _this.itemHeight = 68;
        _this.visibleItems = 4;
        // Listen for Selection Changes
        _this.onSelectionChange.forEach(function (event) {
            _this.value = event.source.value;
            _this.viewValue = event.source['viewValue'];
            if (event.isUserInput)
                _this.close();
            cdRef.markForCheck();
        });
        // Update UI on Value Change
        _this.valueChange.subscribe(function () { return _this.selectOption(); });
        return _this;
    }
    UkDropdownComponent_1 = UkDropdownComponent;
    /** ===> Manage Focus <=== */
    UkDropdownComponent.prototype.onInputFocus = function () { this.focused = true; };
    UkDropdownComponent.prototype.onInputBlur = function () { this.focused = false; };
    /** ===> HTML Events Bindings <=== */
    UkDropdownComponent.prototype._keyDown = function (event) {
        if (this.disabled)
            return;
        this._handleKeydown(event);
    };
    /** ===> On Items Change <=== */
    UkDropdownComponent.prototype.proccessItems = function (list) {
        _super.prototype.proccessItems.call(this, list);
        if (this._hasPendingChange) {
            this.selectOption();
        }
    };
    UkDropdownComponent.prototype.selectOption = function () {
        var _this = this;
        if (this.value && this._items && this._items.length > 0) {
            this._hasPendingChange = false;
            var _nSitem = this._items.find(function (i) { return i.value === _this.value; });
            if (_nSitem) {
                this.select(_nSitem);
            }
        }
        if (!this._items) {
            this._hasPendingChange = true;
        }
    };
    Object.defineProperty(UkDropdownComponent.prototype, "_ariaLabel", {
        /** ===> Manage UI <=== */
        get: function () {
            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
        },
        enumerable: true,
        configurable: true
    });
    /** ===> Manage Menu Visibility <=== */
    UkDropdownComponent.prototype.toggle = function () {
        if (this.disabled)
            return;
        this.isMenuOpen ? this.close() : this.open();
    };
    UkDropdownComponent.prototype.open = function () {
        this._triggerRect = this.trigger.nativeElement.getBoundingClientRect();
        this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement)['font-size']);
        this.isMenuOpen = true;
        this.cdRef.detectChanges();
    };
    UkDropdownComponent.prototype.close = function () {
        if (this.isMenuOpen) {
            this.isMenuOpen = false;
        }
        this.cdRef.detectChanges();
    };
    /** ===> Overriding navigate functionality <=== */
    UkDropdownComponent.prototype.navigate = function (event, select) {
        if (select === void 0) { select = false; }
        if (this.isMenuOpen) {
            var minHeight = this.itemHeight * Math.floor(this.visibleItems / 2);
            var currentHeight = this.itemHeight * (this.selectedIndex + 1);
            if (minHeight < currentHeight) {
                this.panel.nativeElement.scrollTop = currentHeight - minHeight;
            }
            else {
                this.panel.nativeElement.scrollTop = 0;
            }
        }
        _super.prototype.navigate.call(this, event, select);
    };
    // ===> Manage HTML Events <===ccb
    UkDropdownComponent.prototype._handleKeydown = function (event) {
        if (!IS_SYSTEM_KEY(event))
            event.preventDefault();
        this.isMenuOpen ? this._handleOpenKeyDown(event) : this._handleClosedKeyDown(event);
    };
    UkDropdownComponent.prototype._handleClosedKeyDown = function (event) {
        var key = event.key;
        var isOpenKey = key === KEYS.Enter || key === KEYS.Space;
        if (isOpenKey) {
            event.preventDefault();
            this.open();
        }
        else {
            this.navigate(event, true);
        }
    };
    UkDropdownComponent.prototype._handleOpenKeyDown = function (event) {
        var key = event.key;
        event.preventDefault();
        if (IS_LETTER_KEY(key)) {
            var items = this._items.toArray().
                filter(function (x) {
                return x.viewValue.toUpperCase().indexOf(key.toUpperCase()) > -1;
            });
            if (items.length) {
                this.focusElement(items[0]);
            }
        }
        switch (key) {
            case KEYS.ArrowDown:
            case KEYS.ArrowLeft:
            case KEYS.ArrowRight:
            case KEYS.ArrowUp: {
                this.navigate(event);
                break;
            }
            case KEYS.Enter: {
                this.selectCorrect();
                break;
            }
            case KEYS.Escape: {
                this.close();
                break;
            }
        }
    };
    UkDropdownComponent.prototype.focusElement = function (item) {
        if (!item.disabled) {
            var currentItem = this._items.find(function (i) { return i.active; });
            if (currentItem && currentItem !== item) {
                currentItem.active = false;
                currentItem.selected = false;
            }
            var el = item['element'];
            el.nativeElement.parentElement.scrollTo(0, el.nativeElement.offsetTop);
            item.active = true;
            item.selected = true;
            this._selectedIndex = item.index;
            this.onSelectionChange.emit(new UkSelectionChange(item, false));
        }
    };
    var UkDropdownComponent_1;
    __decorate([
        HostBinding('class.uk-dropdown'),
        HostBinding('class.uk-input'),
        HostBinding('class.disabled'),
        HostBinding('attr.role'),
        __metadata("design:type", Object)
    ], UkDropdownComponent.prototype, "role", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkDropdownComponent.prototype, "placeholder", void 0);
    __decorate([
        Input('aria-labelledby'),
        __metadata("design:type", String)
    ], UkDropdownComponent.prototype, "ariaLabelledby", void 0);
    __decorate([
        Input('aria-label'),
        __metadata("design:type", String)
    ], UkDropdownComponent.prototype, "ariaLabel", void 0);
    __decorate([
        Input('aria-describedby'),
        __metadata("design:type", String)
    ], UkDropdownComponent.prototype, "ariaDescribedby", void 0);
    __decorate([
        Input('tabindex'),
        __metadata("design:type", Object)
    ], UkDropdownComponent.prototype, "tabidx", void 0);
    __decorate([
        ViewChild('trigger', { static: false }),
        __metadata("design:type", ElementRef)
    ], UkDropdownComponent.prototype, "trigger", void 0);
    __decorate([
        ViewChild('panel', { static: false }),
        __metadata("design:type", ElementRef)
    ], UkDropdownComponent.prototype, "panel", void 0);
    __decorate([
        HostListener('focus'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkDropdownComponent.prototype, "onInputFocus", null);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkDropdownComponent.prototype, "onInputBlur", null);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], UkDropdownComponent.prototype, "_keyDown", null);
    UkDropdownComponent = UkDropdownComponent_1 = __decorate([
        Component({
            selector: 'uk-dropdown',
            template: "<div cdk-overlay-origin class=\"uk-dropdown__trigger\" \r\n  #origin=\"cdkOverlayOrigin\" #trigger\r\n  (click)=\"toggle()\">  \r\n  <div class=\"uk-dropdown__select\" [ngSwitch]=\"!viewValue\">\r\n    <span class=\"uk-dropdown__select-placeholder\" *ngSwitchCase=\"true\">\r\n      {{placeholder || '\\u00A0'}}\r\n    </span>\r\n    <span class=\"uk-dropdown__select-value\" *ngSwitchCase=\"false\">\r\n      {{viewValue}}\r\n    </span>\r\n  </div>\r\n  <div class=\"uk-dropdown__arrow-wrapper\">\r\n    <div class=\"uk-dropdown__arrow\"></div>\r\n  </div>\r\n</div>\r\n<ng-template \r\n  cdkConnectedOverlay\r\n  cdkConnectedOverlayLockPosition\r\n  cdkConnectedOverlayHasBackdrop\r\n  [cdkConnectedOverlayOrigin]=\"origin\"\r\n  [cdkConnectedOverlayOpen]=\"isMenuOpen\"\r\n  [cdkConnectedOverlayMinWidth]=\"_triggerRect?.width\"\r\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\r\n  (backdropClick)=\"close()\"\r\n  (detach)=\"close()\">\r\n  <div #panel class=\"uk-dropdown__panel\"\r\n    [style.font-size.px]=\"_triggerFontSize\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>\r\n",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.Default,
            providers: [{
                    provide: UkBaseFormControl,
                    useExisting: forwardRef(function () { return UkDropdownComponent_1; })
                }]
        }),
        __param(0, Self()), __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl, ChangeDetectorRef])
    ], UkDropdownComponent);
    return UkDropdownComponent;
}(UkFormGroupComponent));

var UkOverlayRef = /** @class */ (function () {
    function UkOverlayRef(overlayRef) {
        this.overlayRef = overlayRef;
    }
    UkOverlayRef.prototype.close = function () {
        this.overlayRef.dispose();
    };
    return UkOverlayRef;
}());

var UkDropdownOverlayService = /** @class */ (function () {
    /**
     *
     * @param _overlay Overlay Service
     */
    function UkDropdownOverlayService(_overlay) {
        this._overlay = _overlay;
    }
    /**
     * Returns an OverlayRef (which is a PortalHost)
     * @returns UkOverlayRef
     */
    UkDropdownOverlayService.prototype.open = function () {
        var overlayRef = this._overlay.create();
        var ukOverlay = new UkOverlayRef(overlayRef);
        return ukOverlay;
    };
    UkDropdownOverlayService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Overlay])
    ], UkDropdownOverlayService);
    return UkDropdownOverlayService;
}());

var UkDropdownModule = /** @class */ (function () {
    function UkDropdownModule() {
    }
    UkDropdownModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                OverlayModule,
                FormsModule,
                UIKitCommonModule,
                UkFormControlsModule
            ],
            declarations: [UkDropdownComponent, UkSelectTrigger],
            providers: [UkDropdownOverlayService],
            exports: [UkDropdownComponent, UkSelectTrigger],
            entryComponents: [UkDropdownComponent]
        })
    ], UkDropdownModule);
    return UkDropdownModule;
}());

export { UkDropdownModule, UkOverlayRef, UkSelectTrigger as ɵa, UkDropdownComponent as ɵb, UkDropdownOverlayService as ɵc };
//# sourceMappingURL=uikit-components-uk-dropdown.js.map
